import React, { useState } from "react";
import ExpandIcon from "assets/icon/expand.svg";
import MinimizeIcon from "assets/icon/minimize.svg";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import blackSaveIcon from "assets/icon/black-save-icon.svg";
import plusPurple from "assets/icon/plus-icon-add-note.svg";
import leftArrow from "assets/icon/left-arrow.svg";
import closeIcon from "assets/icon/close.svg";
import addBlackIcon from "assets/icon/add-black-icon.svg";
import addIcon from "assets/icon/add.svg";
const ClaimInformation = ({
  openCliams,
  expand,
  setExpand,
  setClaimInformation,
}) => {
  // const [claimInformation, setClaimInformation] = useState(false);
  const [active, setActive] = useState("tab-1");
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [input, setInput] = useState("Dur Override Codes");
  const [editIndex, setEditIndex] = useState(null);

  const [selectedOptions, setSelectedOptions] = useState({ data: "" });

  const [allergies, setAllergies] = useState([
    {
      id: 1,
      data: "20: 340B Eligiblee",
      id: 2,
      data: "20: 340B Eligible nnn",
      id: 3,
      data: "20: 340B Eligiblennn",
    },
  ]);

  const handleSubmit = () => {
    if (selectedOptions.data) {
      setAllergies((prev) => [
        ...prev,
        { id: Date.now(), data: selectedOptions.data },
      ]);
      setSelectedOptions({ data: "" });
    }
  };

  const handleDeleteAl = (id) => {
    setAllergies((prev) => prev.filter((item) => item.id !== id));
  };

  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: value }));
  };
  const handelKeyChange = (e) => {
    setKey(e.target);
  };

  const handleClick = (e) => {
    setActive(e.target.id);
  };

  const handleAddTask = () => {
    if (input.trim() === "") return;

    if (editIndex !== null) {
      const updatedTasks = [...tasks];
      updatedTasks[editIndex] = input;
      setTasks(updatedTasks);
      setEditIndex(null);
    } else {
      setTasks([...tasks, input]);
    }
    setInput("");
  };
  const handleEdit = (index) => {
    setInput(tasks[index]);
    setEditIndex(index);
  };

  const handleRemove = (index) => {
    setTasks(tasks.filter((_, i) => i !== index));
  };
  return (
    <div
      className=" p-3 "
      style={{
        overflow: "auto",
        height: "80vh",
        width: expand ? "82vw" : "50vw",
      }}
    >
      <div className="d-flex justify-content-end">
        <div
          className="expand-btn mb-2"
          onClick={() => setClaimInformation(false)}
        >
          {" "}
          <img src={leftArrow} className="cursor-pointer left-arrow-btn" /> Go
          Back to Rx
        </div>
        <div className="expand-btn mb-2" onClick={() => setExpand(!expand)}>
          <img src={expand ? MinimizeIcon : ExpandIcon} alt="not available" />
          Expand Details
        </div>
      </div>

      <div className="claim-box d-flex justify-content-between align-items-center mb-2">
        <div>
          <div>
            <span className="c-heading">1. Medicare Part D </span>
            <span className="claim-rejected">Claim Rejected</span>
          </div>
          <span className="c-sub-sub">
            Refill too soon (next fill date: 1/27/2024)
          </span>
          <div className="d-flex justify-content-between flex-start">
            <div>
              <span className="c-code">BIN:</span>{" "}
              <span className="c-code-number">098779</span>
            </div>
            <div>
              <span className="c-code">PCN:</span>{" "}
              <span className="c-code-number">MEDST</span>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-start">
            <div>
              <span className="c-code">Group:</span>{" "}
              <span className="c-code-number">MEDICAID</span>
            </div>
            <div>
              <span className="c-code">ID :</span>{" "}
              <span className="c-code-number"> JD123456789</span>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center flex-column flex-start gap-2 ">
          <Button color="primary">Pend Rx</Button>
          <Button
            className="back-button"
            style={{ backgroundColor: "transparent" }}
          >
            Override
          </Button>
        </div>
      </div>
      <div className="c-state-medi d-flex justify-content-between align-items-center mb-2">
        <div>
          <div>
            <span className="c-heading">2. State Medicaid </span>
          </div>

          <div className="d-flex justify-content-between flex-start">
            <div>
              <span className="c-code">BIN:</span>{" "}
              <span className="c-code-number">098779</span>
            </div>
            <div>
              <span className="c-code">PCN:</span>{" "}
              <span className="c-code-number">MEDST</span>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-start">
            <div>
              <span className="c-code">Group:</span>{" "}
              <span className="c-code-number">MEDICAID</span>
            </div>
            <div>
              <span className="c-code">ID :</span>{" "}
              <span className="c-code-number"> JD123456789</span>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center flex-column flex-start gap-2 ">
          <Button color="primary">Submit</Button>
          <Button
            className="back-button"
            style={{ backgroundColor: "transparent" }}
          >
            Override
          </Button>
        </div>
      </div>
      <div className="c-state-medi d-flex justify-content-between align-items-center mb-2">
        <div>
          <div>
            <span className="c-heading">3. Commercial Insurance </span>{" "}
            <span className="claim-paid">Claim Paid</span>
          </div>
          <span
            className="f-12"
            style={{ color: "#339900", fontWeight: "500" }}
          >
            Payment: $25.67
          </span>

          <div className="d-flex justify-content-between flex-start">
            <div>
              <span className="c-code">BIN:</span>{" "}
              <span className="c-code-number">098779</span>
            </div>
            <div>
              <span className="c-code">PCN:</span>{" "}
              <span className="c-code-number">MEDST</span>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-start">
            <div>
              <span className="c-code">Group:</span>{" "}
              <span className="c-code-number">MEDICAID</span>
            </div>
            <div>
              <span className="c-code">ID :</span>{" "}
              <span className="c-code-number"> JD123456789</span>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center flex-column flex-start gap-2 ">
          <Button color="primary">Submit</Button>
          <Button
            className="back-button"
            style={{ backgroundColor: "transparent" }}
          >
            Override
          </Button>
        </div>
      </div>
      <div className="bin_info">
        <div className="btn-container">
          <div className="btncroll">
            <button
              className={`btn-tab ${active === "tab-1" ? "active" : ""}`}
              id="tab-1"
              onClick={handleClick}
            >
              {/* <img src={InfoIcon} alt="" style={{ marginRight: "10px" }} /> */}
              DUR
            </button>
            <button
              id="tab-2"
              className={`btn-tab ${active === "tab-2" ? "active" : ""}`}
              onClick={handleClick}
            >
              {" "}
              {/* <img
                    src={MedicationIcon}
                    alt=""
                    style={{ marginRight: "10px" }}
                  /> */}
              SCC
            </button>
            <button
              id="tab-7"
              className={`btn-tab ${active === "tab-7" ? "active" : ""}`}
              onClick={handleClick}
            >
              {" "}
              {/* <img
                    src={ProgramIcon}
                    alt=""
                    style={{ marginRight: "10px" }}
                  /> */}
              Summary
            </button>

            <button
              id="tab-6"
              className={`btn-tab ${active === "tab-6" ? "active" : ""}`}
              onClick={handleClick}
            >
              {" "}
              {/* <img
                    src={DocumentIcon}
                    alt=""
                    style={{ marginRight: "10px" }}
                  /> */}
              Other Coverage
            </button>
            <button
              id="tab-5"
              className={`btn-tab ${active === "tab-5" ? "active" : ""}`}
              onClick={handleClick}
            >
              {" "}
              {/* <img
                    src={PreferencesIcon}
                    alt=""
                    style={{ marginRight: "10px" }}
                  /> */}
              History
            </button>
          </div>
        </div>
      </div>
      <div className="tab-content">
        <div className={`tab-page  ${active === "tab-1" ? "active" : ""}`}>
          <div className="input-section">
            <FormGroup>
              <InputGroup>
                <Input
                  // style={{ backgroundColor: "white" }}
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Search by Payer, BIN or PCN"
                  className="f-16 f-w-600 bg-white"
                />
                <div onClick={handleAddTask} className="add-new-plan">
                  <img src={plusPurple} alt="" />
                  {editIndex !== null ? "Update" : "Add"}
                </div>
              </InputGroup>
            </FormGroup>
            <div className="bg-light  mt-2 p-2">
              <div className="d-flex justify-content-between">
                <div>
                  <span className="f-w-500 f-14">DUR Override -1</span>
                </div>
                <div>
                  <span onClick={() => handleEdit(index)} className="edit-btn">
                    Edit
                  </span>
                  &nbsp;
                  <span
                    onClick={() => handleRemove(index)}
                    className="remove-btn"
                  >
                    Remove
                  </span>
                </div>
              </div>
              <div>
                {expand ? (
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>

                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>
                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>

                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm={12}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>
                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
          <div className="input-section mt-2">
            <div className="bg-light p-2">
              <div className="d-flex justify-content-between">
                <div>
                  <span className="f-w-500 f-14">DUR Override -1</span>
                </div>
                <div>
                  <span onClick={() => handleEdit(index)} className="edit-btn">
                    Edit
                  </span>
                  &nbsp;
                  <span
                    onClick={() => handleRemove(index)}
                    className="remove-btn"
                  >
                    Remove
                  </span>
                </div>
              </div>
              <div>
                {expand ? (
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>

                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>
                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>

                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm={12}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>
                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
          {tasks.map((task, index) => (
            <div key={index} className="bg-light p-2">
              <div className="d-flex justify-content-between">
                <div>
                  <span>DUR Override -1</span>
                </div>
                <div>
                  <span onClick={() => handleEdit(index)} className="edit-btn">
                    Edit
                  </span>
                  &nbsp;
                  <span
                    onClick={() => handleRemove(index)}
                    className="remove-btn"
                  >
                    Remove
                  </span>
                </div>
              </div>
              <div>
                {expand ? (
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>

                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>
                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>

                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm={12}>
                      <FormGroup>
                        <p className="claim-label">Reason for Service</p>
                        <InputGroup>
                          <Input type="text" />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className={`tab-page ${active === "tab-2" ? "active" : ""}`}>
          <div>
            <div className="p-2 m-0">
              <InputGroup className="bg-white">
                <Input
                  placeholder="Enter to Add SCC"
                  name="data"
                  value={selectedOptions.data}
                  onChange={handleChangeOption}
                />
                <div onClick={handleSubmit} className="add-new-plan">
                  <img src={plusPurple} alt="" />
                  Add
                </div>
              </InputGroup>
              <div
                className="d-flex justify-content-start align-items-center direction-row gap-2"
                style={{
                  height: "auto",
                  overflowX: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                {allergies.map((name) => (
                  <div
                    className={name.data ? "allergies-add-data-pack" : ""}
                    key={name.id}
                  >
                    <div onClick={() => handleDeleteAl(name.id)}>
                      <img
                        src={name.data ? closeIcon : ""}
                        alt=""
                        className="cursor-pointer"
                      />
                    </div>
                    <div>{name.data}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={`tab-page ${active === "tab-3" ? "active" : ""}`}>
          <div>In Development</div>
        </div>
        <div className={`tab-page ${active === "tab-4" ? "active" : ""}`}>
          In Development
        </div>
        <div className={`tab-page ${active === "tab-5" ? "active" : ""}`}>
          <div>In Development</div>
        </div>
        <div className={`tab-page ${active === "tab-6" ? "active" : ""}`}>
          <div>In Development</div>
        </div>
        <div className={`tab-page ${active === "tab-7" ? "active" : ""}`}>
          In Development
        </div>
        <div className={`tab-page ${active === "tab-8" ? "active" : ""}`}>
          <div>In Development</div>
        </div>
      </div>
    </div>
  );
};

export default ClaimInformation;
